import { ApiConfig, HttpService, QueryHandler, TaggedUrl, Tags } from '@skylab-shared/core';
import { MS_PER_MINUTE } from '@skylab-shared/utils';
import { ReportPrintQuery, ReportPrintQueryParameters, ReportPrintResult } from '../queries/report-print.query-base';


export interface UnsettledPaymentsPrintingResult extends ReportPrintResult { }

export interface UnsettledPaymentsPrintingParameters extends ReportPrintQueryParameters { }

export class UnsettledPaymentsPrintingQuery extends ReportPrintQuery<UnsettledPaymentsPrintingResult> {
    public constructor(parameters: UnsettledPaymentsPrintingParameters) {
        super(parameters);
    }
}

export class UnsettledPaymentsPrintingQueryHandlerBase implements QueryHandler<UnsettledPaymentsPrintingQuery, UnsettledPaymentsPrintingResult> {
    private static Url = TaggedUrl.join('unsettledPayment/printing', [Tags.Api]);

    public constructor(private readonly http: HttpService) {  }

    public async handleAsync({ parameters }: UnsettledPaymentsPrintingQuery): Promise<UnsettledPaymentsPrintingResult> {
        const requestData = {
            compress: parameters.compress,
            password: parameters.password,
            ecoMode: parameters.ecoMode,
            landscape: parameters.landscape,
            config: {
                parameters: JSON.stringify(parameters.parameters),
                columns: parameters.columns,
                summary: parameters.summary,
                report: 'NaleznosciNierozliczone'
            }
        };

        const { data } = await this.http.post<{ url: string; }>(UnsettledPaymentsPrintingQueryHandlerBase.Url, requestData, {timeout: 3 * MS_PER_MINUTE });

        return {
            url: `${ApiConfig.baseUrl}${data.url}`
        };
    }
}
